import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

export const GetFTOList = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.GET_FTO_LIST}`, data);
};

export const GetListFromDate = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.GET_FTO_LIST_BY_DATES}`, data);
};

export const SubmitNewFTORequest = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.CREATE_FTO_REQUEST}`, data);
};

export const GetFTODetails = async (ftoId) => {
  return axios.get(`${api.ATTENDANCE_CHANGE.GET_FTO_BY_ID}?FtoId=${ftoId}`);
};

export const SubmitApproval = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.APPROVE_OR_DENY_FTO}`, data);
};

export const GetFTODetailsForMail = async (ftoId) => {
  return axios.get(`${api.ATTENDANCE_CHANGE.GET_FTO_BY_ID_FOR_MAIL}?FtoId=${ftoId}`);
};

export const SubmitApprovalViaMail = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.APPROVE_OR_DENY_FTO_MAIL}`, data);
};

export const UpdateAttendanceFto = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.UPDATE_FTO}`, data);
}

export const AddOrUpdateVisitor = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.ADD_OR_UPDATE_VISITOR}`,data);
};

export const AddOrUpdateRecordingReq = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.RecordingReq}`,data);
};
export const GetAllRecordings = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GetAllRecording}`,data);
};
export const GetAllPlantLibrary = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.GetAllPlantLibrary}`,data);
};
export const ApproveRecordingViaMail = async (data) => {
  return axios.post(`${api.HUMAN_RESOURCE.ApproveRecordingViaMail}`,data);
};

export const AddOrUpdateVisitorWithoutLogin = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.ADD_OR_UPDATE_VISITOR_WITHOUT_LOGIN}`,data);
};
export const GetAllVisitors = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.GET_ALL_VISITOR}`,data);
};

export const GetAllLunchPerson = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.GET_ALL_LUNCH_PERSON}`,data);
};

export const GetVisitorById = async (visitorId) => {
  return axios.get(`${api.ATTENDANCE_CHANGE.GET_VISITOR_BY_ID}?Id=${visitorId}`);
};
export const DeleteVisitorById = async (visitorId) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.DELETE_VISITOR_BY_ID}?Id=${visitorId}`);
};

export const DownloadVisitorPdf = async (visitorId, type) => {
  return axios.get(`${api.ATTENDANCE_CHANGE.DOWNLOAD_VISITOR}?Id=${visitorId}&type=${type}`);
};

export const VisitorApprovalViaMail = async (data) => {
  return axios.post(`${api.ATTENDANCE_CHANGE.APPROVAL_OR_DENIED_VISITOR_VIA_MAIL}`, data);
};

export const GetFtoType = async (data) => {
  return axios.get(`${api.ATTENDANCE_CHANGE.GET_FTO_TYPE}`, data);
};

export const GetLeaveSummery = async (data) => {
   
  return axios.post(`${api.ATTENDANCE_CHANGE.GET_LEAVE_SUMMERY}`, data);
};

export const ExportApproveFto = async () => {
  return axios.get(`${api.ATTENDANCE_CHANGE.EXPORT_APPROVE_FTO}`, {
    responseType: 'blob',
  });
}

